import React, { Component } from "react";
import _ from "lodash";
import ThemeableAgGrid from "../../../common/components/agGrid/ThemeableAgGrid";
import Loading from "../../../common/components/loading/loading";
import { getTermScheduleHistory } from "../../../common/services/markets/termScheduleService";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

class TermScheduleHistory extends Component {
  state = {
    termScheduleHistory: [],
    isLoading: true,
  };

  async componentDidMount() {
    const { termScheduleId } = this.props;
    const termScheduleHistory = this.mapToViewModel(
      await getTermScheduleHistory(termScheduleId)
    );

    this.setState({
      termScheduleHistory: _.orderBy(termScheduleHistory, "id", "desc"),
      isLoading: false,
    });
  }

  mapToViewModel(termSchedules) {
    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    return termSchedules.map((termSchedule) => ({
      id: termSchedule.id,
      name: termSchedule.name,
      forwardReportingPeriodicity: termSchedule.forwardReportingPeriodicity,
      historicalReportingPeriodicity:
        termSchedule.historicalReportingPeriodicity,
      active: termSchedule.active,
      updatedByUserAccountId: termSchedule.createdByUserAccountId,
      updatedBy:
        termSchedule.updatedByUserAccountFirstName +
        " " +
        termSchedule.updatedByUserAccountLastName,
      updatedDate: new Date(termSchedule.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      writeDate: new Date(termSchedule.writeDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      eventId: termSchedule.eventId,
    }));
  }

  getColumnDefs() {
    const { t } = this.props;
    return [
      {
        field: "id",
        headerName: t("RecordID"),
        sortable: true,
        filter: true,
      },
      {
        field: "name",
        headerName: t("TermScheduleName"),
        sortable: true,
        filter: true,
      },
      {
        field: "forwardReportingPeriodicity",
        headerName: t("ForwardReportingPeriodicity"),
        sortable: true,
        filter: true,
      },
      {
        field: "historicalReportingPeriodicity",
        headerName: t("HistoricalReportingPeriodicity"),
        sortable: true,
        filter: true,
      },
      {
        field: "active",
        headerName: t("Active"),
        flex: 1,
        // Apply centered class for better alignment
        cellClass: "ag-center-aligned-cell",
        headerClass: "ag-center-aligned-header",
        filterValueGetter: (params) => params.data.activeString,
        cellRenderer: (params) => {
          const isActive = params.data?.active;
          return (
            <div className="centered" style={{ width: "100%", height: "100%" }}>
              <FontAwesomeIcon
                icon={isActive ? faCheck : faTimes}
                className={isActive ? "text-success" : "text-danger"}
                style={{ fontSize: "16px" }}
              />
            </div>
          );
        },
      },
      {
        field: "updatedBy",
        headerName: t("UpdatedBy"),
        sortable: true,
        filter: true,
      },
      {
        field: "updatedDate",
        headerName: t("UpdateDate"),
        sortable: true,
        filter: true,
      },
      {
        field: "writeDate",
        headerName: t("WriteDate"),
        sortable: true,
        filter: true,
      },
      {
        field: "eventId",
        headerName: t("EventID"),
        sortable: true,
        filter: true,
      },
    ];
  }

  getGridOptions() {
    return {
      pagination: true,
      paginationPageSize: 10,
      paginationPageSizeSelector: [10, 20, 50, 100],
      suppressPaginationPanel: false,
      domLayout: "normal",
    };
  }

  handleSortChanged = (event) => {
    const { api } = event;
    const columnState = api.getColumnState();
    const sortedColumn = columnState.find((col) => col.sort);

    if (sortedColumn) {
      this.setState({
        sortColumn: {
          field: sortedColumn.colId,
          order: sortedColumn.sort,
        },
      });
    }
  };

  render() {
    const { termScheduleHistory, isLoading } = this.state;

    if (isLoading) return <Loading />;

    const { t, termScheduleId } = this.props;

    return (
      <div className="history-table-container">
        {t("TermScheduleID")} {termScheduleId}
        <div style={{ height: "600px", width: "100%" }}>
          <ThemeableAgGrid
            className="table-extra-small"
            columnDefs={this.getColumnDefs()}
            rowData={termScheduleHistory}
            domLayout="autoHeight"
            gridOptions={this.getGridOptions()}
            onSortChanged={this.handleSortChanged}
            getRowId={(params) => params.data.id.toString()}
            animateRows={true}
          />
        </div>
      </div>
    );
  }
}

export default withTranslation(["markets"])(TermScheduleHistory);

